export const mainInfoImgSizes = {
	tiny: {
		width: 640,
		height: 480,
	},
	small: {
		width: 866,
		height: 640,
	},
	medium: {
		width: 1100,
		height: 1000,
	},
	large: {
		width: 1100,
		height: 1000,
	},
};
